import moment from 'moment';
import 'twix';
import jquery from 'jquery';
import c from '@/components/Core/constants.js'
function getEventForTheDate(date, data) {
	var eventObj = [];
	for (let i = 0; i < data.CalendarList.length; i++) {
		let c = data.CalendarList[i];
		const range = moment(c.FromDate, 'MM/DD/YYYY').twix(moment(c.ToDate, 'MM/DD/YYYY'), true);
		if (range.contains(moment(date).format('YYYY/MM/DD'))) {
			var _totalHoursPerDay =
				c.HoursPerDay && c.HoursPerDay.length > 0
					? c.HoursPerDay.filter((x) => {
						return moment(x.Date).format('YYYY/MM/DD') == moment(date).format('YYYY/MM/DD');
					})
					: [];
			var x = {
				Status: c.Status,
				ExpenseStatus: c.ExpenseStatus,
				CalendarType: c.CalendarType,
				eventId: c.Id,
				totalHoursPerDate:
					_totalHoursPerDay[0] != null && _totalHoursPerDay.length > 0 ? _totalHoursPerDay[0].Hours : 0,
				TimesheetlatestLog: c.TimesheetlatestLog,
				ExpenselatestLog: c.ExpenselatestLog,
				InvoiceStatus:c.InvoiceStatus,
				InvoiceDates:c.InvoiceDates
			};
			eventObj.push(x);
		}
	}
	return eventObj;
}
function createCell(label, date, data) {
	let eventData = null;

	if (date) {
		eventData = getEventForTheDate(date, data);
	}
	let dateSpanStyle = 'margin-top: 12px;display: inline-block;font-size: 12px;font-weight: 800';
	let classes = 'fc-ob-cell';
	var eventIds = [];
	var totalTimeColr = '';

	if (eventData != null && eventData.length > 0) {
		let isTimesheet = false;
		var hrs = 0;
		var min = 0;
		for (let k = 0; k < eventData.length; k++) {
			var x = eventData[k];
			var innerSpan = '';
			eventIds[k] = x.eventId;
			let total = new Array();
			if (x.totalHoursPerDate != null && x.totalHoursPerDate != undefined && x.totalHoursPerDate != '') {
				total = x.totalHoursPerDate.split(' ');
			}
			var h = 0;
			var m = 0;
			if (total.length == 2) {
				h = total[0];
				m = total[1];
				if (h) {
					hrs = hrs + (parseInt(h.replace('h', '')) || 0);
				}
				if (m) {
					min = min + (parseInt(m.replace('m', '')) || 0);
				}
			} else if (total.length == 1) {
				if (total[0].includes('h')) {
					h = total[0];
				} else if (total[0].includes('m')) {
					m = total[0];
				}
				if (h) {
					hrs = hrs + (parseInt(h.replace('h', '')) || 0);
				}
				if (m) {
					min = min + (parseInt(m.replace('m', '')) || 0);
				}
			}
			if (x.CalendarType == 'TimeSheet' && (x.Status != 'None' && x.ExpenseStatus != 'None')) {
				if (x.CalendarType == 'TimeSheet' && (x.ExpenseStatus == 'Approved')) {
					isTimesheet = true;
					if(x.Status == 'Approved' && x.InvoiceStatus == 'Invoice Generated' && x.InvoiceDates.includes(date)){
						if (k == 0) {
						    classes += ' fc-ce-bg fc-ce-timesheet-invoiceGenerated';
							totalTimeColr = '#A31D95';
						}
						else if(k > 0){
							totalTimeColr = '#A31D95';
						}
						 else innerSpan = `display: block;`;
					}
					else if ((x.TimesheetlatestLog != null && x.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit') || (x.ExpenselatestLog != null && x.ExpenselatestLog.Status == 'EmployeeRequestedForEdit')) {
						if (k == 0) {
							classes += ' fc-ce-bg fc-ce-timesheet-EmployeeRequestedForEdit';
							totalTimeColr = '#AA99D6';
						} else innerSpan = `display: block;`;
					}
					else {
						if (k == 0) {
							classes += ' fc-ce-bg fc-ce-timesheet-approved';
							if (x.Status == 'Approved') {
								totalTimeColr = '#13DA7C';
							}
							else if (x.Status == 'Pending') {
								totalTimeColr = '#F8D21C';
							}
							else if (x.Status == 'Rejected') {
								totalTimeColr = '#ef4457';
							}
						} else innerSpan = `display: block;`;
					}
				} else if (x.CalendarType == 'TimeSheet' && (x.ExpenseStatus == 'Pending')) {
					isTimesheet = true;
					if(x.Status == 'Approved' && x.InvoiceStatus == 'Invoice Generated' && x.InvoiceDates.includes(date)){
						if (k == 0) {
						    classes += ' fc-ce-bg fc-ce-timesheet-invoiceGenerated';
							totalTimeColr = '#A31D95';
						}
						else if(k > 0){
							totalTimeColr = '#A31D95';
						}
						else innerSpan = `display: block;`;
					}
					else if (k == 0) {
						classes += ' fc-ce-bg fc-ce-timesheet-pending';
						if (x.Status == 'Approved') {
							totalTimeColr = '#13DA7C';
						}
						else if (x.Status == 'Pending') {
							totalTimeColr = '#F8D21C';
						}
						else if (x.Status == 'Rejected') {
							totalTimeColr = '#ef4457';
						}
					} else innerSpan = `display: block;`;
				} else if (x.CalendarType == 'TimeSheet' && (x.ExpenseStatus == 'Rejected')) {
					isTimesheet = true;
					if(x.Status == 'Approved' && x.InvoiceStatus == 'Invoice Generated' && x.InvoiceDates.includes(date)){
						if (k == 0) {
						    classes += ' fc-ce-bg fc-ce-timesheet-invoiceGenerated';
							totalTimeColr = '#A31D95';
						} 
						else if(k > 0){
							totalTimeColr = '#A31D95';
						}
						else innerSpan = `display: block;`;
					}
					if (k == 0) {
						classes += ' fc-ce-bg fc-ce-timesheet-rejected';
						if (x.Status == 'Approved') {
							totalTimeColr = '#13DA7C';
						}
						else if (x.Status == 'Pending') {
							totalTimeColr = '#F8D21C';
						}
						else if (x.Status == 'Rejected') {
							totalTimeColr = '#ef4457';
						}
					} else innerSpan = `display: block;`;
				}
			}
			else if (x.CalendarType == 'TimeSheet') {
				
				if (x.CalendarType == 'TimeSheet' && (x.Status == 'Approved' || x.ExpenseStatus == 'Approved')) {
					isTimesheet = true;
					if(x.Status == 'Approved' && x.InvoiceStatus == 'Invoice Generated' && x.InvoiceDates.includes(date)){
						if (k == 0) {
						    classes += ' fc-ce-bg fc-ce-timesheet-invoiceGenerated';
							totalTimeColr = '#A31D95';
						} 
						else if(k > 0){
							totalTimeColr = '#A31D95';
						}
						else innerSpan = `display: block;`;
					}
					else if ((x.TimesheetlatestLog != null && x.TimesheetlatestLog.Status == 'EmployeeRequestedForEdit') || (x.ExpenselatestLog != null && x.ExpenselatestLog.Status == 'EmployeeRequestedForEdit')) {
						if (k == 0) {
							classes += ' fc-ce-bg fc-ce-timesheet-EmployeeRequestedForEdit';
							totalTimeColr = '#AA99D6';
						} else innerSpan = `display: block;`;
					}
					else {
						if (k == 0) {
							classes += ' fc-ce-bg fc-ce-timesheet-approved';
							totalTimeColr = '#13DA7C';
						} else innerSpan = `display: block;`;
					}
				} else if (x.CalendarType == 'TimeSheet' && (x.Status == 'Pending' || x.ExpenseStatus == 'Pending')) {
					isTimesheet = true;
					if (k == 0) {
						classes += ' fc-ce-bg fc-ce-timesheet-pending';
						totalTimeColr = '#F8D21C';
					} else innerSpan = `display: block;`;
				} else if (x.CalendarType == 'TimeSheet' && (x.Status == 'Rejected' || x.ExpenseStatus == 'Rejected')) {
					isTimesheet = true;
					if (k == 0) {
						classes += ' fc-ce-bg fc-ce-timesheet-rejected';
						totalTimeColr = '#ef4457';
					} else innerSpan = `display: block;`;
				}
			}
			else if (x.CalendarType == 'Leave' && x.Status == 'Pending') {
				if (k == 0) {
					classes += ' fc-ce-bg fc-ce-leave-pending';
					totalTimeColr = '#35373a';
				} else innerSpan = `display: block;background:rgb(217, 217, 217,0.7)`;
			} else if (x.CalendarType == 'Leave' && x.Status == 'Approved') {
				if (k == 0) {
					classes += ' fc-ce-bg fc-ce-leave-approved';
					totalTimeColr = '#1F27F2';
				} else innerSpan = `display: block;background:rgb(	223, 228, 247,0.7)`;
			} else if (x.CalendarType == 'Holiday') {
				if (k == 0) {
					classes += ' fc-ce-bg fc-ce-org-holiday';
					totalTimeColr = '#B28B61';
				} else innerSpan = `display: block;background:#EEECE9`;
			}
		}
		var hours = min / 60;
		var rhours = Math.floor(hours);
		var minutes = (hours - rhours) * 60;
		var rminutes = Math.round(minutes);
		var totalHours = parseInt(hrs) + parseInt(rhours);
		let _totalhoursWorked = '-';

		if (isTimesheet == true) {
			if (totalHours != 0 && rminutes != 0) {
				dateSpanStyle = 'display: inline-block;font-size: 12px;font-weight: 800';
				_totalhoursWorked = `<span style="display: block !important;padding-top: 2px;">${totalHours +
					'h '}</span><span>${rminutes + 'm'}</span>`;
			} else if (totalHours != 0 && rminutes == 0) {
				dateSpanStyle = 'display: inline-block;font-size: 12px;font-weight: 800';
				_totalhoursWorked = `<span style="display: block !important;padding-top: 11px;padding-bottom: 7px;">${totalHours +
					'h '}</span>`;
			} else if (totalHours == 0 && rminutes != 0) {
				dateSpanStyle = 'display: inline-block;font-size: 12px;font-weight: 800';
				_totalhoursWorked = `<span style="display: block !important;padding-top: 11px;padding-bottom: 7px;">${rminutes +
					'm'}</span>`;
			} else {
				dateSpanStyle = 'display: inline-block;font-size: 12px;font-weight: 800';
				_totalhoursWorked = `<span style="display: block !important;padding-top: 11px;padding-bottom: 7px;">0h</span>`;
			}
		} else {
			dateSpanStyle = 'display: inline-block;font-size: 12px;font-weight: 800';
			_totalhoursWorked = `<span style="display: block !important;padding-top: 11px;">-</span>`;
		}
		var left = 0;
		var right = 0;
		var innerSpanStyle = '';
		if (!allEvtIds.includes(eventIds[1])) {
			innerSpan += `;margin: 0px 0px 0px 2px`;
		}
		if (allEvtIds.some((v) => eventIds.indexOf(v) !== -1)) {
			allEvtIds = allEvtIds.concat(eventIds);
			left = 0;
			right = 0;
		} else {
			allEvtIds = allEvtIds.concat(eventIds);
			left = '5%';
			right = '5%';
		}
		if (eventIds.length > 1) {
			innerSpanStyle = innerSpan;
		} else {
			innerSpanStyle = '';
		}
		return `<td c_date=${date}><div  style="padding-right: 10px;" class="${classes}" data-employee-id='${data.EmployeeId}' data-event-id='${eventIds}'>&nbsp;<span style="left:${left};right:${right};color:${totalTimeColr}"><span style="${innerSpanStyle}"> <span style="${dateSpanStyle}">${_totalhoursWorked}</span></span></span></div></td>`;
	}
	return `<td c_date=${date}><div style="padding-right: 10px;" class="${classes}">&nbsp;<span><span style="${dateSpanStyle}">-</span></span></div></td>`;
}
function getMonthlyHours(Data, month) {
	var data = Data.CalendarList.filter((v) => v.Status != 'Rejected')
	var hoursPerDayList = data.filter((v) => v.HoursPerDay != null).map(function (v) {
		return v.HoursPerDay;
	});
	var mergedhoursPerDayList = [].concat.apply([], hoursPerDayList);
	var mergedhoursPerDayListCurrentMonth = mergedhoursPerDayList.filter((x) => {
		return moment(x.Date).format('MM') == month;
	});
	var hrs = 0;
	var min = 0;
	let monthlyHours = '0h';
	for (var j = 0; j < mergedhoursPerDayListCurrentMonth.length; j++) {
		var x = mergedhoursPerDayListCurrentMonth[j];
		let total = new Array();
		if (x.Hours != null && x.Hours != undefined && x.Hours != '') {
			total = x.Hours.split(' ');
		}
		var h = 0;
		var m = 0;
		if (total.length == 2) {
			h = total[0];
			m = total[1];
			if (h) {
				hrs = hrs + (parseInt(h.replace('h', '')) || 0);
			}
			if (m) {
				min = min + (parseInt(m.replace('m', '')) || 0);
			}
		} else if (total.length == 1) {
			if (total[0].includes('h')) {
				h = total[0];
			} else if (total[0].includes('m')) {
				m = total[0];
			}
			if (h) {
				hrs = hrs + (parseInt(h.replace('h', '')) || 0);
			}
			if (m) {
				min = min + (parseInt(m.replace('m', '')) || 0);
			}
		}
	}
	var hours = min / 60;
	var rhours = Math.floor(hours);
	var minutes = (hours - rhours) * 60;
	var rminutes = Math.round(minutes);
	var totalHours = parseInt(hrs) + parseInt(rhours);

	if (totalHours != 0 && rminutes != 0) {
		monthlyHours = `<span class="hours_span">${totalHours +
			'</span><p class="hours_p">h</p> <span class="hours_span">'}${rminutes +
			'</span><p class="hours_p">m</p>'}`;
	} else if (totalHours != 0 && rminutes == 0) {
		monthlyHours = `<span class="hours_span">${totalHours + '</span><p class="hours_p">h</p>'}`;
	} else if (totalHours == 0 && rminutes != 0) {
		monthlyHours = `<span class="hours_span">${rminutes + '</span><p class="hours_p">m</p>'}`;
	} else {
		monthlyHours = `<span class="hours_span">0</span><p class="hours_p">h</p>`;
	}
	return monthlyHours;
}

function createEmployeeCell(data, month) {
	const dropDownContent = '<i style="border:1px solid #eadfdf;border-radius: 3px;width:12px;height:17px;padding-left:5px" class="fa fa-sort-desc" aria-hidden="true"></i>';;
	const iconContent = `<img data-v-57823a2e="" src="${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/alert.svg" style="height:20px">`
	let IsDCAAComplianceToggleOn = localStorage.getItem('IsDCAAComplianceToggleOn');

	let iconCheck = (!(data.IsTimeSheetSubmited) && (IsDCAAComplianceToggleOn != 'false')) ? iconContent : dropDownContent;
	let profilePicLink = data.ProfileLink ? data.ProfileLink : `${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/noimage.svg`;
	let name = data.EmployeeName ? data.EmployeeName : 'N/A';
	let designation = data.Designation ? data.Designation : 'N/A';
	let monthlyHours = getMonthlyHours(data, month);
	let monthlyExpense = data.MonthlyExpenses;
	let ConsultantId = data.ConsultantId;
	let WorkAuthorizationType = data.WorkAuthorizationType;
	let HireType = data.HireType;

	return `
    <td>
      <div class="fc-ob-cell">
        <div style="cursor:pointer;height: 40px;padding-top: 8px;"  class="employee-details clearfix">
          <div emp_id="${data.EmployeeId}" emp_name="${name}" background_img="${profilePicLink}"  style="background: url(${profilePicLink}) no-repeat;background-size: 30px 30px !important;" class="employer_background_image_calender left"></div>
          <div class="right employee_name">
			<span class="text text-name" title="${name}">
				<span class="text-emp-name" onclick="window.open('ReportingEmployees/employee-evaluation-trainee?EmployeeId=${data.EmployeeId}','_blank');">
					${name}
				</span>
			</span>
            <span style="cursor:auto" class="text text-designation" title="${designation}">${designation}</span>
          </div>
          <div class="monthly-hours">
		  <div class="hrtooltip">
		  <img style="width: 12px;padding-bottom: 5px;" src="${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_totalhours.svg"/>
		  <span class="hrtooltiptext">Total hours worked</span>
		 </div>
            <span class="text text-name" style="display: inline-block;margin-left: 6px;padding-top: 3px;"><b>${monthlyHours}</b></span>
		  </div>
		  <div class="monthly-hours">
					<img style="width: 12px;padding-bottom: 5px;" src="${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_dollar.svg"/>
			        <span class="text text-name" style="display: inline-block;margin-left: 6px;padding-top: 3px;"><b>${monthlyExpense}</b></span>
		  </div>
		  
		</div>
		<div emp_id="${data.EmployeeId}" style="position:absolute;top:15px;right:25px;" class="Expense-re">${iconCheck}</div>
		</div>
      </div>
    </td>
  `;
}
function EnumerateDaysBetweenDates(startDate, endDate) {
	var now = startDate,
		dates = [];
	while (now.isSameOrBefore(endDate)) {
		dates.push(now.format('MM/DD/YYYY'));
		now.add(1, 'days');
	}
	return dates;
}
const MonthsRender = (year, month, data) => {
	let tempDOM = '';

	tempDOM += `<div class="fc-ob-months-render-container"><table class="fc-ob-months-render">`;

	tempDOM += `<tr>`;
	tempDOM += createEmployeeCell(data, month);

	const datefrom = moment(`${year}-${month}-01`).startOf('month').format('MM/DD/YYYY');
	const dateTo = moment(`${year}-${month}-01`).endOf('month').format('MM/DD/YYYY');

	const week_start_date = moment(datefrom).startOf('week').format('MM/DD/YYYY');
	const week_end_date = moment(dateTo).endOf('week').format('MM/DD/YYYY');
	var fromDateDiffList = EnumerateDaysBetweenDates(moment(week_start_date), moment(datefrom).add(-1, 'days'));
	var toDateDiffList = EnumerateDaysBetweenDates(moment(dateTo).add(1, 'days'), moment(week_end_date));

	let currentMonthDateList = EnumerateDaysBetweenDates(moment(datefrom), moment(dateTo));
	var dateArrayList = fromDateDiffList.concat(currentMonthDateList).concat(toDateDiffList);

	for (var i = 0; i < dateArrayList.length; i++) {
		let date = moment(dateArrayList[i]).format('YYYY-MM-DD');
		tempDOM += createCell('-', date, data);
	}

	//	let startDash = 0;
	//	let prependDiff = m.days + d - 35;
	//	if (prependDiff > 0) {
	// 	for (var i = 0; i < prependDiff; i++) {
	// 		let t = m.days - (prependDiff - 1 - i);
	// 		tempDOM += createCell(t, m.YYYYMM + '-' + t, data);
	// 	}
	// 	startDash = prependDiff;
	// }

	// for (var i = startDash; i < d; i++) {
	// 	tempDOM += createCell('-', null, data);
	// }

	// for (var i = 1; i <= limit; i++) {
	// 	if (i > m.days) {
	// 		tempDOM += createCell('-', null, data);
	// 	} else {
	// 		tempDOM += createCell(i, m.YYYYMM + '-' + i, data);
	// 	}
	// }

	tempDOM += `</tr>`;
	// } else {
	// 	tempDOM += `<tr>`;
	// 	tempDOM += createEmployeeCell(data, month);

	// 	for (var i = 1; i <= 35; i++) {
	// 		if (i > m.days) {
	// 			tempDOM += createCell('-', null, data);
	// 		} else {
	// 			tempDOM += createCell(i, m.YYYYMM + '-' + i, data);
	// 		}
	// 	}

	// 	tempDOM += `</tr>`;
	// }

	tempDOM += `</table></div>`;

	return tempDOM;
};

export default MonthsRender;



// WEBPACK FOOTER //
// ./src/components/ESSProfile/Timesheets/Calender/CustomViews/Monthly/MonthsRender/MonthsRender.js